import {axios} from '@js/utilities/axios.js';
export default {
	namespaced: true,
	state: {
		notifications: {
			data: [],
			meta: {},
		},
		count: null,
	},
	actions: {
		fetchNotifications({commit}, params) {
			return axios.get('/api/notifications', {
				params: params
			}).then(response => {
				commit('setNotifications', response.data);
			}).catch(error => {
				toastr.error('An error occurred while fetching notifications');

				throw error;
			});
		},
		fetchCount({commit}) {
			return axios.get('/api/notifications/count').then(response => {
				commit('setCount', response.data);
			}).catch(error => {
				toastr.error('An error occurred while fetching notifications');

				throw error;
			});
		},
		archiveNotification(context, notification_id) {
			return axios.delete(`/api/notifications/${notification_id}`).then(() => {
				toastr.success('Notification archived successfully');

        context.dispatch('fetchCount');
        context.dispatch('fetchNotifications');
			}).catch(error => {
				toastr.error('An error occurred while archiving the notification');

				throw error;
			});
		},
	},
	getters: {
		getNotifications(state) {
			return state.notifications;
		},
		getCount(state) {
			return state.count;
		}
	},
	mutations: {
		setNotifications(state, notifications) {
			state.notifications = notifications;
		},
		setCount(state, count) {
			state.count = count;
		}
	}
}
